module.exports = __webpack_public_path__ + "static_portal/img/body_parts_speed.6a920675.jpg";